import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { TranslateResolveService } from './service/translate-resolve.service';
import { WfProcessEditorComponent } from './wf-process-editor.component';

const routes: Routes = [
  {
    path: 'WfProcessEditor', component: WfProcessEditorComponent,
    children: [],
    resolve: {
      'translate': TranslateResolveService
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class WfProcessEditorRoutingModule { }
